{
    "GenericAdminList_Footer_Add": "Toevoegen",
    "GenericAdminList_Footer_View": "Weergave",
    "GenericAdminList_Footer_Change": "Wijziging",
    "GenericAdminList_Footer_Delete": "Verwijderen",
    "GenericAdminList_Footer_Selected": "{} Geselecteerd",
    "GenericAdminList_Footer_NoRows": "Hier is niets te zien...",
    "NAME": "GenericAdminListLanguage"
}